export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

interface Props {
    date1?: string | null
    date2?: string | null
    date3?: string | null
}

export default class extends Component<Props> {
    static template = template;
    static defaults() {
        return {
            date1: null,
            date2: null,
            date3: null
        } as Props;
    }
}